import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantAdminAuditLogMenuRegistry = {
    core_tenantAdminAuditLog: {
        label: "Tenant Admin Audit Log",
        link: PAGE_URL.TENANT_ADMIN_AUDIT_LOG_PAGE,
        key: PAGE_URL.TENANT_ADMIN_AUDIT_LOG_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantAdminAuditLogMenuRegistry;
